import { parseNotionPageMd } from './parse-page-md.js';

function stripDuplicateLeadingH1(markdown: string, pageTitle: string): string {
  const normalizedTitle = pageTitle.trim().toLowerCase();
  if (!normalizedTitle) {
    return markdown;
  }

  const lines = markdown.split('\n');
  let i = 0;
  while (i < lines.length && lines[i]!.trim() === '') {
    i++;
  }
  if (i >= lines.length) {
    return markdown;
  }

  const h1Match = lines[i]!.match(/^#\s+(.+)$/);
  if (!h1Match) {
    return markdown;
  }

  if (h1Match[1]!.trim().toLowerCase() !== normalizedTitle) {
    return markdown;
  }

  i++;
  while (i < lines.length && lines[i]!.trim() === '') {
    i++;
  }

  return lines.slice(i).join('\n').trimStart();
}

/** Notion database row exports often list schema fields as `Key: value` lines. */
function isNotionPropertyLine(line: string): boolean {
  if (line.startsWith('#')) {
    return false;
  }
  if (/^[-*+]\s/.test(line) || line.startsWith('```')) {
    return false;
  }
  if (/^https?:\/\//i.test(line)) {
    return false;
  }
  const match = line.match(/^([^:]+):\s*(.*)$/);
  if (!match) {
    return false;
  }
  const key = match[1]!.trim();
  return key.length > 0 && key.length <= 80;
}

/**
 * True when a database row `.md` file has wiki-style body content beyond the row
 * title and exported property fields (title-only rows should stay CSV-only).
 */
export function isSubstantialDatabaseRowMd(text: string, title: string): boolean {
  const { body } = parseNotionPageMd(text);
  const trimmed = stripDuplicateLeadingH1(body, title).trim();
  if (!trimmed) {
    return false;
  }

  const lines = trimmed
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.length > 0);

  return lines.some((line) => !isNotionPropertyLine(line));
}

export function normalizeTitleForRowMatch(title: string): string {
  return title.trim().toLowerCase();
}
